export const SITE_INFO = {
  companyName: "Shaktisetu Info Solutions LLP",
  email: "help@shaktisetu.com",
  phone: "+91 8369288191",
  supportHours: "8am to 9pm everyday",
  address:
    "FLAT NO-T-2-402, PLOT NO. D69, SKP HOUSING SOCIETY PVT LTD, SECTOR 12, 410210, MAHARASHTRA, INDIA",
  grievanceOfficer: "Mrs Sangeeta Bhalekar",
  foundedYear: "2025",
  appleStoreUrl: "https://apps.apple.com/in/app/shaktisetu/id6759998685",
  playStoreUrl:
    "https://play.google.com/store/apps/details?id=com.shaktisetu.candidate",
};

export const HERO_CONTENT = {
  title: "Unlocking the Potential of India's Workforce",
  subtitle:
    "Connecting tech-enabled talent with verified local opportunities. From AI-curated profiles to one-click hiring, we're organizing the future of work, starting with Mumbai.",
  primaryCTA: "Start Your Journey",
  secondaryCTA: "Build Your Team",
};

export const MISSION_CONTENT = {
  title: "Our Mission",
  text: "To organize the labor industry by connecting India's tech-enabled youth with trustworthy employers within their locality, ensuring transparency and dignity for every worker.",
};

export const ABOUT_CONTENT = {
  story:
    "Founded in 2025, ShaktiSetu was born from a simple 'Aha!' moment: the realization that while India's workforce is tech-enabled, the labor market remained fragmented and unorganized. We saw employers struggling with unverified paper resumes and high attrition, while talented candidates missed out on local opportunities due to lack of visibility.",
  vision:
    "To create a transparent ecosystem where the dignity of labor is upheld, and technology bridges the gap between potential and placement.",
  coreBeliefs: [
    {
      title: "Transparency",
      detail: "Removing misinformation and hidden hurdles for both sides.",
    },
    {
      title: "Dignity of Work",
      detail: "Treating every role with the respect it deserves.",
    },
    {
      title: "Trust",
      detail: "Providing a verified workforce to reduce employer attrition.",
    },
    {
      title: "Accessibility",
      detail: "Connecting youth with opportunities within their locality.",
    },
  ],
  aiValuePoint:
    "Our AI-first approach eliminates the 'resume gap.' Candidates fill out a simple mobile form, and our AI generates a standardized, professional digital profile—no Word or LaTeX hassle required. For employers, this means no more manual sorting of unformatted CVs; instead, you get a clean, data-rich view of every applicant.",
};

export const FEATURES_CONTENT = {
  talent: {
    title: "Your Digital Career Partner",
    items: [
      {
        title: "AI Digital Profile",
        detail:
          "Transform your experience into a premium, industry-standard digital profile automatically.",
      },
      {
        title: "Verified Only",
        detail:
          "Apply to pre-screened local opportunities with complete confidence in employer legitimacy.",
      },
      {
        title: "Real-time Clarity",
        detail:
          "Know exactly where you stand with instant SMS notifications at every stage of hiring.",
      },
      {
        title: "Hyper-Local Match",
        detail:
          "Find the best opportunities right in your neighborhood, minimizing commute and maximizing life.",
      },
    ],
  },
  employer: {
    title: "Recruitment, Reimagined",
    items: [
      {
        title: "AI-Powered Screening",
        detail:
          "Get instant applicant summaries and JD match scores to find your top 10% in seconds.",
      },
      {
        title: "Rapid Shortlisting",
        detail:
          "Access standardized digital profiles that eliminate the hassle of unformatted resumes.",
      },
      {
        title: "Frictionless Hiring",
        detail:
          "Schedule interviews and generate digital offer letters with a single, professional click.",
      },
      {
        title: "Zero Cost Ecosystem",
        detail:
          "A high-performance recruitment platform that empowers your growth at absolutely no cost.",
      },
    ],
  },
};

export const TESTIMONIALS = {
  recruiters: [
    {
      id: 1,
      quote:
        "ShaktiSetu reduced our hiring time by 50%. The verified profiles make a huge difference.",
      author: "Hiring Manager",
      company: "TechCorp",
    },
    {
      id: 2,
      quote:
        "Quality of candidates is outstanding. The platform is intuitive and efficient.",
      author: "HR Director",
      company: "Retail Inc",
    },
    {
      id: 3,
      quote: "Finally a platform that understands modern recruitment needs.",
      author: "CEO",
      company: "StartupX",
    },
    {
      id: 4,
      quote: "The end-to-end tracking is a lifesaver for our recruitment team.",
      author: "Talent Acquisition",
      company: "Global Logistics",
    },
  ],
  candidates: [
    {
      id: 1,
      quote:
        "I got a job at DMart in 2 days. The verification process was so smooth!",
      author: "Rahul S.",
      role: "Store Manager",
    },
    {
      id: 2,
      quote: "Best app for finding real jobs without any middlemen or fees.",
      author: "Priya M.",
      role: "Delivery Associate",
    },
    {
      id: 3,
      quote: "The digital profile really helped me stand out to employers.",
      author: "Amit K.",
      role: "Warehouse Supervisor",
    },
    {
      id: 4,
      quote: "ShaktiSetu changed my life. I found a stable job within a week.",
      author: "Suresh P.",
      role: "Security Guard",
    },
  ],
};

export const TERMS_CONTENT = [
  "Terms & Conditions",
  "Effective as of December 2025. By using ShaktiSetu, you agree to these legal terms.",
  "1. FOR CANDIDATES",
  "ShaktiSetu is a facilitator providing digital profile curation and AI-powered job matching. By using our platform, you agree to undergo voluntary identity and PAN verification through our authorized partners. Your data will only be shared with verified employers for the purpose of recruitment.",
  "2. FOR EMPLOYERS",
  "Employers must provide accurate job descriptions and adhere to professional hiring standards. ShaktiSetu acts as a technology bridge.",
  "3. SERVICE FEES",
  "Certain placements involves a one-time placement fee. For candidates, this is typically settled via employer deduction upon successful hiring. Transparency is maintained throughout the offer lifecycle.",
  "4. DATA & PRIVACY",
  "We prioritize data security. Fake accounts, misinformation, or unauthorized scraping are strictly prohibited and will lead to immediate termination.",
];

export const PRIVACY_CONTENT = [
  "Privacy Policy",
  "Your trust is our priority. Here is how we protect your information.",
  "1. DATA COLLECTION",
  "We collect basic profile data (name, phone) and identity details (PAN) strictly for industrial verification. We do not sell your personal data.",
  "2. DISCLOSURE",
  "Candidate data is visible only to verified employers on the ShaktiSetu Portal. Identity verification is processed through compliant third-party gateways.",
  "3. SECURITY",
  "All data is encrypted in transit and at rest. You maintain the right to request data deletion at any time via support.",
];

export const REFUND_CONTENT = [
  "Refund Policy",
  "ShaktiSetu facilitates professional placements. A one-time placement fee applies upon successful hiring.",
  "1. GENERAL POLICY",
  "This fee is non-refundable once the placement is confirmed and the service is rendered, except in cases of technical errors or double-billing. For any assistance, please reach out to us at help@shaktisetu.com.",
  "2. DOUBLE-BILLING REFUNDS",
  "In the event of double-billing, approved refunds will be processed and credited back to your original payment method within 7–10 business days.",
];
